var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 802.06665 590.74664",
    height: 590.74664,
    width: 802.06665,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,590.74667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#f3f2f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2440.53,1555.68 1318.48,805.18 213.402,2457.36 1335.46,3207.85 2440.53,1555.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1860.86,1634.02 -12.73,-78.81 -557.79,80.36 12.74,78.8 557.78,-80.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1579.95,1915.15 80.04,-11.54 -88.74,-549.17 -80.04,11.53 88.74,549.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1066.18,2613.16 c 0.8,-1.2 -111.645,-77.81 -251.114,-171.1 -139.527,-93.32 -253.246,-167.98 -254.039,-166.78 -0.8,1.19 111.621,77.79 251.141,171.11 139.473,93.29 253.222,167.96 254.012,166.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1478.82,2716.74 c 0.8,-1.2 -186.19,-127.67 -417.59,-282.44 -231.488,-154.84 -419.73,-279.34 -420.531,-278.14 -0.801,1.19 186.149,127.64 417.631,282.46 231.41,154.78 419.69,279.32 420.49,278.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1561.53,2593.08 c 0.81,-1.2 -186.18,-127.67 -417.59,-282.44 C 912.457,2155.8 724.211,2031.3 723.414,2032.49 c -0.801,1.2 186.149,127.64 417.636,282.47 231.4,154.78 419.68,279.31 420.48,278.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1644.25,2469.42 c 0.8,-1.2 -186.19,-127.67 -417.59,-282.45 -231.492,-154.83 -419.734,-279.33 -420.535,-278.14 -0.797,1.19 186.145,127.64 417.635,282.47 231.4,154.78 419.69,279.31 420.49,278.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1726.96,2345.75 c 0.8,-1.2 -186.19,-127.67 -417.59,-282.44 -231.49,-154.83 -419.729,-279.34 -420.53,-278.14 -0.801,1.19 186.15,127.63 417.63,282.46 231.41,154.78 419.69,279.31 420.49,278.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#f3f2f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 6015.48,713.02 5073.14,82.7383 4145.08,1470.28 5087.41,2100.57 6015.48,713.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5528.65,778.82 -10.69,-66.191 -468.44,67.492 10.7,66.18 468.43,-67.481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5292.75,1014.91 67.21,-9.67 -74.53,-461.22 -67.22,9.679 74.54,461.211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4861.26,1601.12 c 0.8,-1.19 -93.52,-65.68 -210.66,-144.03 -117.18,-78.38 -212.79,-140.92 -213.59,-139.72 -0.8,1.2 93.52,65.68 210.7,144.05 117.12,78.35 212.75,140.91 213.55,139.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5207.8,1688.12 c 0.8,-1.19 -156.13,-107.56 -350.47,-237.55 -194.41,-130.03 -352.6,-234.45 -353.4,-233.24 -0.8,1.19 156.1,107.53 350.5,237.56 194.35,129.99 352.57,234.43 353.37,233.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5277.28,1584.26 c 0.8,-1.19 -156.15,-107.56 -350.48,-237.55 -194.41,-130.03 -352.61,-234.43 -353.41,-233.24 -0.79,1.19 156.1,107.54 350.52,237.57 194.33,129.99 352.57,234.42 353.37,233.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5346.74,1480.4 c 0.8,-1.19 -156.13,-107.56 -350.48,-237.55 -194.4,-130.03 -352.6,-234.43 -353.4,-233.24 -0.8,1.19 156.1,107.54 350.51,237.57 194.34,129.99 352.57,234.42 353.37,233.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5416.2,1376.55 c 0.8,-1.2 -156.13,-107.56 -350.47,-237.55 -194.41,-130.03 -352.6,-234.441 -353.4,-233.25 -0.81,1.199 156.09,107.54 350.5,237.58 194.34,129.98 352.57,234.42 353.37,233.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#f3f2f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2786.9,1633.33 1758.72,2183.22 2568.41,3697.19 3596.6,3147.3 2786.9,1633.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2610.89,2106.93 -65.24,-22.34 -165.57,457.74 65.23,22.34 165.58,-457.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2710.9,2435.31 23.76,-65.68 -454.59,-155.69 -23.76,65.69 454.59,155.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3033.91,3110.68 c -0.8,-1.51 -105.09,52.7 -232.9,121.05 -127.85,68.37 -230.8,125 -230,126.51 0.8,1.51 105.07,-52.69 232.92,-121.06 127.8,-68.36 230.79,-125 229.98,-126.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3280.64,2838.35 c -0.81,-1.51 -173.4,89.22 -385.44,202.63 -212.13,113.45 -383.37,206.6 -382.57,208.1 0.8,1.51 173.36,-89.21 385.48,-202.65 212.05,-113.41 383.33,-206.58 382.53,-208.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3220.03,2725.03 c -0.8,-1.51 -173.39,89.22 -385.44,202.63 -212.12,113.44 -383.37,206.6 -382.56,208.11 0.8,1.5 173.36,-89.21 385.48,-202.66 212.04,-113.41 383.33,-206.58 382.52,-208.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3159.42,2611.71 c -0.8,-1.51 -173.38,89.22 -385.43,202.63 -212.12,113.45 -383.37,206.6 -382.57,208.11 0.81,1.5 173.36,-89.21 385.48,-202.66 212.05,-113.4 383.34,-206.58 382.52,-208.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#dadbd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3098.82,2498.39 c -0.8,-1.51 -173.39,89.23 -385.44,202.63 -212.12,113.45 -383.37,206.6 -382.56,208.11 0.8,1.51 173.36,-89.21 385.48,-202.65 212.04,-113.41 383.33,-206.59 382.52,-208.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#c3c5c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3078.38,3990.78 h 25.832 v 439.832 h -25.832 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2488.99,3458.72 H 3693.6 c 0,0 -111.22,532.34 -611.43,532.34 -444.92,0 -593.18,-532.34 -593.18,-532.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3104.21,4430.61 h -25.83 v -439.83 h 25.83 v 439.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5773.33,32.3281 c 0,-1.4375 -1292.51,-2.6093 -2886.53,-2.6093 C 1292.23,29.7188 0,30.8906 0,32.3281 c 0,1.4336 1292.23,2.6016 2886.8,2.6016 1594.02,0 2886.53,-1.168 2886.53,-2.6016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 319.523,658.59 c 33.813,-1.18 65.547,-19.539 87.852,-44.981 22.301,-25.437 35.973,-57.437 44.715,-90.109 16.922,-63.238 6.523,-137.859 -11.512,-200.781 -68.457,24.461 -110.676,97.472 -129.762,135.851 -30.171,60.66 -47.863,188.621 8.707,200.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 539.082,246.078 c -21.602,31.004 -22.109,74.133 -5.031,107.852 17.074,33.718 49.875,58.031 86.004,69.129 16.703,5.121 36.09,7.281 50.621,-2.418 13.582,-9.082 19.453,-26.879 17.699,-43.129 -1.746,-16.242 -9.984,-31.102 -19.687,-44.242 -33.286,-45.071 -73.77,-82.579 -129.606,-87.192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 546.617,34.7695 c -0.332,-0.0507 -1.367,4.6407 -3.062,13.1289 -1.828,9.3829 -4.2,21.5 -7.039,36.0508 -5.403,30.3008 -13.977,73.3908 -7.493,121.0308 6.231,47.418 25.114,87.969 44.903,112.18 9.746,12.25 19.066,20.922 25.969,26.25 3.339,2.801 6.285,4.531 8.148,5.852 1.914,1.258 2.965,1.847 3.059,1.718 0.746,-0.839 -16.004,-11.16 -34.512,-35.859 -18.75,-24.289 -36.727,-64.141 -42.863,-110.769 -6.383,-46.672 1.519,-89.372 6.089,-119.8403 2.45,-15.2929 4.426,-27.6914 5.563,-36.3125 1.137,-8.5976 1.551,-13.3789 1.238,-13.4297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 341.602,562.34 c 0.152,0.07 1.093,-1.711 2.757,-5.18 1.825,-3.941 4.164,-8.98 7.051,-15.23 6.051,-13.282 14.559,-32.59 24.863,-56.539 20.625,-47.891 48.196,-114.45 76.973,-188.629 28.766,-74.223 53.289,-141.973 70.344,-191.242 8.535,-24.6411 15.273,-44.6294 19.75,-58.5083 2.078,-6.5703 3.758,-11.8711 5.062,-16.0117 1.11,-3.6719 1.618,-5.6406 1.461,-5.6914 -0.148,-0.0469 -0.961,1.8008 -2.363,5.3711 -1.523,4.0703 -3.48,9.2812 -5.902,15.7305 -5.2,14.25 -12.383,33.9101 -21.168,57.9808 -17.856,48.968 -42.86,116.488 -71.606,190.648 -28.758,74.129 -55.816,140.852 -75.64,189.051 -9.743,23.699 -17.7,43.07 -23.465,57.101 -2.559,6.399 -4.625,11.571 -6.239,15.59 -1.375,3.578 -2.023,5.508 -1.878,5.559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 465.355,174.57 c -40.375,68.692 -115.75,115.532 -195.218,121.289 -20.239,1.481 -44.578,-1.929 -53.602,-20.109 -9.043,-18.199 3.047,-39.738 16.836,-54.672 57.363,-62.137 154.395,-83.797 232.734,-51.957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 300.953,241.691 c 0.024,0.321 4.524,0.141 12.672,-0.472 4.074,-0.278 9.07,-0.637 14.785,-1.719 5.695,-1.051 12.332,-1.68 19.391,-3.641 7.105,-1.75 14.953,-3.488 23.07,-6.41 8.277,-2.449 16.777,-5.988 25.707,-9.769 17.641,-8.008 36.36,-18.5 54.176,-32.121 17.687,-13.789 32.633,-29.2 44.777,-44.309 5.848,-7.75 11.422,-15.078 15.774,-22.551 4.808,-7.168 8.379,-14.371 11.734,-20.8787 3.594,-6.3906 5.711,-12.7187 8.055,-18.0195 2.375,-5.3125 3.847,-10.1016 5.031,-14.0117 2.426,-7.8086 3.609,-12.1407 3.297,-12.2383 -1.012,-0.3516 -5.875,17.1289 -19.363,42.7305 -3.504,6.3207 -7.188,13.3277 -12.067,20.3087 -4.422,7.25 -10.039,14.379 -15.871,21.93 -12.137,14.71 -26.891,29.742 -44.266,43.281 -17.5,13.379 -35.812,23.789 -53.074,31.89 -8.742,3.829 -17.058,7.469 -25.168,10.028 -7.941,3.051 -15.636,4.953 -22.605,6.883 -28.067,7.097 -46.16,8.058 -46.055,9.089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4840.27,3375.86 c -29.4,-6.77 -43.72,-40.6 -46.5,-70.64 -2.78,-30.05 1.05,-61.78 -11.57,-89.19 -14.21,-30.85 -48.13,-53.59 -49.26,-87.53 -0.68,-20.7 11.6,-40.16 11.02,-60.85 -0.97,-34 -35.64,-59.68 -37.46,-93.64 -1.3,-24.45 14.99,-47.91 11.07,-72.08 -3.06,-18.82 -17.7,-33.64 -23.89,-51.66 -12.34,-35.93 12.34,-75.48 44.49,-95.71 35.83,-22.53 81.71,-28.35 122.03,-15.47 40.32,12.88 74.32,44.23 90.45,83.36 17.79,43.19 13.9,91.82 10.03,138.37 -12.05,145.05 -21,290.36 -26.85,435.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4754.91,2863.97 c -0.63,0.58 8.04,3.15 13.43,15.98 2.62,6.28 3.96,14.71 3.43,24.41 -0.34,9.77 -3.67,20.4 -7.3,32.38 -3.35,11.89 -7.71,25.67 -5.21,41.01 2.52,15.57 13.66,28.35 23.83,40.92 5.11,6.37 10.26,12.98 13.5,20.52 3.41,7.45 4.13,15.98 1.57,23.98 -5.17,16.34 -21.18,28.35 -28.53,47.22 -3.64,9.45 -3.68,19.83 -1.6,29.18 1.97,9.44 5.8,18 9.65,26.17 7.83,16.28 16.45,31.21 19.87,47.05 7.01,31.72 3.74,62 8.52,86.87 4.32,24.92 14.85,43.66 25.28,53.29 5.08,4.98 10,7.63 13.21,9.41 3.42,1.47 5.23,2.15 5.29,1.99 0.34,-0.56 -7.41,-2.94 -17.07,-12.83 -9.64,-9.75 -19.31,-28.08 -23.09,-52.47 -1.98,-12.13 -2.28,-25.77 -2.78,-40.41 -0.51,-14.63 -0.97,-30.52 -4.69,-46.94 -3.48,-16.64 -12.34,-32.16 -19.93,-48.15 -7.52,-15.71 -14.43,-34.13 -7.78,-51.35 6.35,-17.02 22.46,-29.11 28.51,-47.5 2.96,-9.15 1.99,-19.29 -1.87,-27.49 -3.67,-8.34 -9.12,-15.16 -14.33,-21.56 -10.46,-12.64 -20.92,-24.67 -23.31,-38.66 -2.5,-13.92 1.35,-27.35 4.51,-39.23 3.35,-11.9 6.58,-23.1 6.66,-33.27 0.26,-10.08 -1.43,-18.86 -4.47,-25.35 -3.02,-6.53 -7.15,-10.56 -10.25,-12.62 -3.08,-2.11 -5.05,-2.55 -5.05,-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#c0776a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4676.17,2626.95 -90.26,-260.22 -376.44,-20.18 -62.77,-139.68 393.01,-39.76 c 78.37,-32.4 167.9,7.31 196.5,87.14 l 104.88,292.75 -164.92,79.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#c0776a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5454.81,173.629 c 0,0 -275.87,876.191 -281.72,904.631 -5.3,25.71 100.11,656.23 113.39,819.42 l -372.75,-13.9 c 0,0 -0.01,-0.99 -0.03,-2.71 l -158.44,-8.79 141.91,-1791.9402 h 171.53 l -17.01,594.5122 c 105.77,-283.961 257.34,-573.34 257.34,-573.34 l 145.78,72.117"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#ac584f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5058.69,461.781 c 0.15,5.438 -2.08,199.188 -2.08,199.188 -2.14,-11.59 -65.76,168.23 -64.22,179.16 0.79,5.66 66.3,-378.348 66.3,-378.348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#ac584f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4985.14,925.27 c -0.4,0 -0.77,-3.86 -1.11,-10.86 -0.37,-7.012 -0.45,-17.172 0.23,-29.711 0.24,-6.289 0.9,-13.14 1.71,-20.488 0.94,-7.332 1.94,-15.191 3.64,-23.34 3.11,-16.359 7.91,-34.051 14.02,-52.211 12.45,-36.238 26.2,-67.949 35.96,-90.949 4.62,-10.492 8.59,-19.52 11.93,-27.09 2.93,-6.351 4.73,-9.801 5.09,-9.652 0.37,0.14 -0.73,3.871 -3.03,10.48 -2.29,6.61 -5.8,16.102 -10.26,27.77 -8.81,23.39 -21.95,55.34 -34.29,91.261 -6.05,17.989 -10.93,35.372 -14.27,51.43 -1.82,7.988 -2.98,15.711 -4.1,22.918 -1.01,7.223 -1.89,13.961 -2.38,20.16 -1.18,12.371 -1.72,22.453 -2.03,29.434 -0.34,6.969 -0.72,10.84 -1.11,10.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4893.95,71.5117 -0.07,16.1094 175.69,7.6484 0.49,-66.4492 -10.84,-0.7187 c -48.23,-2.8321 -245.42,-10.961 -277.7,-1.293 -35.99,10.8008 112.43,44.7031 112.43,44.7031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5072.51,32.8398 c 0,-0.0703 -1.03,-0.1796 -3.01,-0.3281 -2.59,-0.1601 -5.43,-0.3515 -8.63,-0.5625 -8.63,-0.3984 -19.24,-0.8906 -31.76,-1.4804 -26.83,-1.0469 -63.92,-2.0274 -104.89,-2.2188 -40.99,-0.168 -78.09,0.4805 -104.92,1.3008 -12.53,0.4805 -23.15,0.8789 -31.78,1.2109 -3.2,0.1797 -6.04,0.3399 -8.63,0.4766 -1.98,0.1328 -3.01,0.2422 -3.01,0.3008 0,0.082 1.04,0.1211 3.02,0.1211 2.6,-0.0196 5.44,-0.0508 8.64,-0.0821 8.64,-0.1367 19.26,-0.3164 31.79,-0.5195 26.83,-0.4492 63.91,-0.8594 104.88,-0.6875 40.95,0.1875 78.02,0.918 104.85,1.5977 12.53,0.3203 23.15,0.5898 31.78,0.8125 3.2,0.0585 6.05,0.1093 8.64,0.1601 1.99,0.0078 3.02,-0.0195 3.03,-0.1016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4837.03,27.1914 c -0.65,-0.0898 -1.17,7.5 -5.99,15.1367 -4.69,7.7305 -11.23,11.5821 -10.87,12.1211 0.11,0.5313 7.62,-2.7383 12.67,-11.0078 5.14,-8.2031 4.71,-16.3828 4.19,-16.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4888.51,53.5391 c -0.49,-0.3203 -2.97,2.6797 -5.53,6.6914 -2.57,4 -4.25,7.5078 -3.75,7.8281 0.49,0.3125 2.97,-2.6875 5.53,-6.6875 2.57,-4.0195 4.24,-7.5117 3.75,-7.832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4902.64,61.0781 c -0.39,-0.4375 -3.16,1.3907 -6.17,4.0938 -3.03,2.6875 -5.16,5.2265 -4.77,5.6601 0.38,0.4375 3.15,-1.3906 6.17,-4.082 3.02,-2.6992 5.16,-5.2305 4.77,-5.6719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4911.52,77.6094 c 0.01,-0.5899 -4.07,-1.1211 -9.11,-1.1992 -5.05,-0.0704 -9.14,0.3398 -9.15,0.9296 -0.01,0.5821 4.07,1.1094 9.12,1.1915 5.04,0.0703 9.13,-0.3399 9.14,-0.9219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4914.55,89.25 c 0.21,-0.5195 -4.24,-2.5391 -10.16,-3 -5.92,-0.4805 -10.63,0.8203 -10.51,1.3711 0.09,0.5977 4.71,0.2773 10.34,0.75 5.62,0.418 10.15,1.4687 10.33,0.8789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4882.53,68.7617 c 0.01,-0.2304 -4.3,-0.7734 -11.24,0.0391 -3.46,0.3984 -7.56,1.1992 -11.96,2.5898 -2.2,0.7696 -4.49,1.3477 -6.86,2.7891 -1.11,0.7422 -2.35,1.7812 -2.79,3.4922 -0.47,1.6797 0.42,3.5664 1.68,4.4883 10.72,5.6093 21.49,-0.3985 25.5,-5.9297 2.2,-2.8321 3.22,-5.5821 3.69,-7.4922 0.46,-1.9063 0.43,-3.0078 0.3,-3.0274 -0.39,-0.1406 -0.77,4.418 -5.15,9.5586 -2.15,2.5196 -5.43,4.9805 -9.62,6.211 -3.97,1.1601 -9.61,1.4492 -13.38,-0.961 -1.78,-1.3281 -1.08,-3.4297 0.91,-4.5976 1.85,-1.1914 4.24,-1.9024 6.32,-2.6836 4.26,-1.4375 8.23,-2.3789 11.58,-2.9688 6.73,-1.1601 11.02,-1.1601 11.02,-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4879.62,68.1992 c -0.16,-0.1172 -1.83,2.7422 -1.33,7.8008 0.27,2.4805 1.16,5.4219 3.04,8.2109 1.97,2.5 4.51,5.9493 9.33,5.7579 2.6,-0.3204 3.89,-3.2774 3.48,-5.168 -0.19,-1.9805 -1.07,-3.6719 -1.88,-5.0195 -1.66,-2.8204 -3.55,-5.1016 -5.29,-6.8204 -3.51,-3.4609 -6.29,-4.7812 -6.41,-4.5703 -0.2,0.2696 2.23,2.0196 5.32,5.5899 1.53,1.7812 3.19,4.039 4.68,6.75 1.53,2.3906 2.57,6.6484 -0.26,7.1484 -2.8,0.2695 -5.66,-2.5508 -7.37,-4.7891 -1.76,-2.4414 -2.73,-5.0585 -3.15,-7.3203 -0.84,-4.5781 0.21,-7.4882 -0.16,-7.5703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5068.76,80.6719 c -0.03,-0.4024 -5,0.4492 -12.9,-0.5117 -7.82,-0.8985 -18.7,-4.1485 -28.13,-11.711 -9.44,-7.5898 -14.96,-17.5 -17.52,-24.9492 -2.64,-7.5 -2.88,-12.5391 -3.28,-12.4883 -0.13,0.0078 -0.19,1.2696 -0.02,3.5196 0.18,2.2695 0.71,5.5273 1.87,9.4375 2.27,7.7617 7.78,18.2226 17.62,26.1328 9.84,7.8867 21.24,11.0078 29.31,11.5468 4.07,0.293 7.37,0.1133 9.61,-0.207 2.25,-0.3203 3.47,-0.6523 3.44,-0.7695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4984.62,46.7695 c 0.08,-0.5507 -11.33,-2.3711 -25.53,-2.4179 -14.21,-0.1016 -25.62,1.5976 -25.55,2.1484 0.05,0.6094 11.47,-0.1289 25.54,-0.0391 14.08,0.0586 25.47,0.918 25.54,0.3086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5018.87,47.1406 c 0.43,-0.4218 -0.93,-2.4218 -2.08,-5.039 -1.19,-2.6211 -1.79,-4.9532 -2.38,-4.9102 -0.57,0 -0.92,2.75 0.44,5.7695 1.35,3.0274 3.65,4.6094 4.02,4.1797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5031.73,63.2617 c 0.41,-0.4219 -0.71,-2.2304 -2.51,-4.0703 -1.81,-1.8398 -3.6,-3.0117 -4.02,-2.6016 -0.41,0.4102 0.7,2.2383 2.51,4.0821 1.79,1.8398 3.6,2.9883 4.02,2.5898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5050.17,70.6719 c -0.12,-0.6016 -2.44,-0.5821 -5,-1.5 -2.59,-0.8516 -4.42,-2.2813 -4.88,-1.8906 -0.46,0.3203 1,2.8085 4.19,3.8906 3.18,1.1094 5.87,0.039 5.69,-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5063.31,74.1797 c 0.22,-0.5508 -0.79,-1.4414 -2.23,-2.0078 -1.45,-0.5821 -2.8,-0.5938 -3.01,-0.0508 -0.22,0.5508 0.79,1.4492 2.23,2.0078 1.45,0.582 2.8,0.5899 3.01,0.0508"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5305.6,87 -6.67,14.672 157.15,78.957 27.65,-60.418 -9.59,-5.109 C 5431.31,92.7695 5254.75,4.58203 5221.34,0.191406 5184.08,-4.71094 5305.6,87 5305.6,87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5484.32,124.879 c 0.04,-0.059 -0.86,-0.59 -2.6,-1.539 -2.29,-1.211 -4.8,-2.539 -7.65,-4.031 -7.7,-3.911 -17.18,-8.7 -28.37,-14.368 C 5421.66,92.9805 5388.22,76.8984 5350.93,59.9414 5313.6,43 5279.49,28.3984 5254.67,18.1602 5243.05,13.4609 5233.2,9.48047 5225.2,6.23828 c -3,-1.14844 -5.66,-2.16797 -8.08,-3.09765 -1.86,-0.69141 -2.84,-1.01954 -2.87,-0.94922 -0.02,0.07031 0.91,0.52734 2.71,1.34765 2.38,1.03125 4.97,2.17188 7.91,3.46094 7.94,3.4102 17.71,7.5898 29.22,12.5391 24.67,10.5898 58.67,25.4023 95.96,42.3398 37.28,16.9414 70.79,32.8008 95,44.4021 11.29,5.43 20.87,10.02 28.65,13.758 2.91,1.371 5.48,2.582 7.82,3.68 1.81,0.82 2.77,1.222 2.8,1.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5271.83,23.2617 c -0.56,-0.3398 -4.15,6.3594 -11.67,11.3594 -7.44,5.1289 -15,5.9687 -14.9,6.6094 -0.09,0.5312 8.09,0.6289 16.09,-4.8516 8.05,-5.3789 11,-13.0195 10.48,-13.1172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5307.99,68.3906 c -0.31,-0.4922 -3.81,1.2305 -7.78,3.8282 -3.99,2.6093 -6.96,5.121 -6.63,5.6015 0.32,0.5 3.8,-1.2187 7.79,-3.8203 3.97,-2.6094 6.94,-5.1211 6.62,-5.6094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5317.79,81.0508 c -0.17,-0.5625 -3.44,-0.0195 -7.3,1.1992 -3.87,1.2188 -6.86,2.6602 -6.67,3.2188 0.18,0.5625 3.45,0.0195 7.3,-1.1993 3.86,-1.2187 6.85,-2.6601 6.67,-3.2187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5319.13,99.7813 c 0.25,-0.543 -3.26,-2.6993 -7.82,-4.8399 -4.58,-2.1328 -8.48,-3.4219 -8.73,-2.9023 -0.24,0.5312 3.26,2.6914 7.83,4.832 4.57,2.1406 8.48,3.4299 8.72,2.9102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5317.12,111.629 c 0.4,-0.391 -2.82,-4.051 -8.05,-6.891 -5.2,-2.867 -10.03,-3.609 -10.14,-3.066 -0.16,0.598 4.19,2.199 9.13,4.918 4.96,2.699 8.65,5.5 9.06,5.039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5296.3,79.8281 c 0.11,-0.207 -3.6,-2.4765 -10.26,-4.5664 -3.32,-1.0508 -7.4,-2 -11.99,-2.5429 -2.31,-0.1993 -4.63,-0.6094 -7.39,-0.2579 -1.33,0.2188 -2.88,0.6602 -3.97,2.0274 -1.13,1.3437 -1.09,3.4336 -0.31,4.8008 7.48,9.4922 19.77,8.4414 25.69,5.0312 3.17,-1.6797 5.22,-3.7812 6.43,-5.3203 1.2,-1.5703 1.62,-2.5703 1.52,-2.6406 -0.31,-0.2891 -2.52,3.7109 -8.62,6.6094 -2.99,1.4218 -6.98,2.3125 -11.31,1.7226 -4.1,-0.5703 -9.37,-2.6094 -11.82,-6.3594 -1.08,-1.9414 0.42,-3.5625 2.71,-3.8203 2.18,-0.3203 4.66,0 6.87,0.1485 4.48,0.4179 8.48,1.1914 11.78,2.039 6.62,1.6914 10.52,3.4492 10.67,3.1289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5293.88,78.1211 c -0.1,-0.1797 -2.79,1.75 -4.41,6.5703 -0.77,2.3672 -1.16,5.4297 -0.59,8.7383 0.78,3.0898 1.69,7.2693 6.15,9.0703 2.51,0.781 8.37,-4.2695 8.78,-6.1602 0.62,-1.8789 -2.97,-0.9101 -3.14,-2.4882 -0.37,-3.2422 -1.16,-6.0899 -2.04,-8.3828 -1.78,-4.5899 -3.77,-6.9297 -3.97,-6.7969 -0.29,0.1797 1.21,2.7695 2.56,7.289 0.66,2.25 1.26,5 1.5,8.0704 0.42,2.8085 -0.38,7.1167 -3.15,6.4177 -2.68,-0.9099 -4.13,-4.6404 -4.78,-7.3904 -0.59,-2.9375 -0.41,-5.7305 0.13,-7.9688 1.1,-4.5078 3.26,-6.7382 2.96,-6.9687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5461.32,166.961 c 0.13,-0.371 -4.76,-1.633 -11.56,-5.742 -6.77,-4.02 -15.36,-11.438 -20.87,-22.199 -5.5,-10.79 -6.48,-22.09 -5.76,-29.942 0.66,-7.93 2.51,-12.6171 2.13,-12.7382 -0.13,-0.039 -0.71,1.0704 -1.47,3.211 -0.76,2.1402 -1.62,5.3282 -2.16,9.3792 -1.11,8.011 -0.36,19.8 5.37,31.039 5.75,11.23 14.87,18.761 22.01,22.551 3.58,1.941 6.67,3.121 8.85,3.75 2.18,0.64 3.43,0.82 3.46,0.691"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5398.44,101.578 c 0.29,-0.469 -9.36,-6.7889 -22.29,-12.6678 -12.93,-5.9102 -24.03,-9.0391 -24.2,-8.5118 -0.19,0.5899 10.52,4.5821 23.32,10.4414 12.82,5.8086 22.87,11.2812 23.17,10.7382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5429.53,115.949 c 0.57,-0.211 0.15,-2.59 0.18,-5.449 -0.03,-2.871 0.39,-5.238 -0.18,-5.461 -0.51,-0.23 -1.95,2.141 -1.95,5.461 0,3.309 1.43,5.68 1.95,5.449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5434.66,135.922 c 0.55,-0.211 0.27,-2.32 -0.62,-4.75 -0.88,-2.41 -2.06,-4.211 -2.6,-4 -0.55,0.187 -0.28,2.316 0.61,4.738 0.89,2.422 2.06,4.211 2.61,4.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5448.46,150.238 c 0.13,-0.597 -1.99,-1.539 -3.96,-3.418 -2.01,-1.84 -3.08,-3.898 -3.67,-3.718 -0.56,0.089 -0.24,2.976 2.22,5.257 2.45,2.321 5.34,2.442 5.41,1.879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5459.01,158.82 c 0.42,-0.41 -0.13,-1.64 -1.23,-2.75 -1.08,-1.121 -2.3,-1.679 -2.72,-1.269 -0.42,0.41 0.13,1.64 1.21,2.75 1.09,1.109 2.32,1.679 2.74,1.269"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5262.31,2194.25 -29.26,356.98 150.28,-2.68 c 0,0 6.96,52.63 -15.18,168.09 -13.58,70.79 -60.73,114.22 -113.61,140.02 l 0.01,0.94 -4.58,1.2 c -67.25,31.48 -137.65,35.92 -137.65,35.92 l -184.47,-2.13 c 0,0 -140.92,17.58 -218.92,-82.88 -30.05,-38.69 -123.02,-303.55 -123.02,-303.55 l 221.41,-106.64 -21.07,146.87 c 0,0 4.19,-106.48 17.78,-140.22 7.57,-18.8 29.5,-77.16 29.5,-77.16 l -2.87,-176.15 431.65,41.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5160.53,2603.05 -27.37,-116.66 h 258.31 l -17,195.58 -213.94,-78.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5391.47,2486.39 c 0.02,0.77 -13.03,2.14 -34.19,3.39 -21.18,1.24 -50.47,2.29 -82.85,2.14 -32.38,-0.16 -61.67,-1.56 -82.83,-3.24 -21.15,-1.67 -34.16,-3.46 -34.1,-4.21 0.06,-0.82 13.16,-0.45 34.32,0.19 21.16,0.64 50.36,1.41 82.64,1.57 32.28,0.14 61.5,-0.27 82.67,-0.48 21.17,-0.22 34.3,-0.16 34.34,0.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5149.4,2682.93 c -0.79,-0.03 -1.06,-11.37 -0.86,-29.68 0.19,-18.3 0.86,-43.57 1.94,-71.47 1.08,-27.9 2.38,-53.15 3.6,-71.42 1.22,-18.26 2.38,-29.54 3.17,-29.51 0.78,0.03 1.05,11.37 0.86,29.67 -0.2,18.3 -0.85,43.58 -1.94,71.48 -1.08,27.9 -2.38,53.15 -3.61,71.41 -1.22,18.26 -2.37,29.54 -3.16,29.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#a7a9a8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5126.89,2167.26 c -14.55,0 -28.24,3.58 -41.08,10.07 l 118.7,11.38 c -30.31,-20.74 -71.35,-21.23 -71.35,-21.23 -2.11,-0.15 -4.2,-0.22 -6.27,-0.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#ba2c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5085.81,2177.33 c -125.45,63.38 -171.46,404.56 -171.46,404.56 l 314.83,-346.24 v -19.01 c -5.8,-12 -14.65,-21.07 -24.67,-27.93 l -118.7,-11.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#ba2c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5138.51,2412.54 -20.01,36.62 30.05,202.96 c 0.21,-18.2 0.87,-43.01 1.93,-70.34 0.24,-6.26 0.5,-12.38 0.76,-18.32 l -18.08,-77.07 h 22.93 c 0.43,-3.59 0.83,-5.54 1.15,-5.54 h 0.01 c 0.25,0.01 0.45,1.2 0.6,3.43 0.77,-0.2 2.82,-0.28 5.98,-0.28 2.06,0 4.6,0.04 7.58,0.1 l -32.9,-71.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#ba2c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5156.09,2486.39 h -22.93 l 18.08,77.07 c 0.9,-20.56 1.9,-38.93 2.84,-53.1 0.72,-10.65 1.4,-18.93 2.01,-23.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#0f191d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5163.83,2484 c -3.16,0 -5.21,0.08 -5.98,0.28 0,0.06 0,0.12 0.01,0.19 l 13.57,-0.33 -0.02,-0.04 c -2.98,-0.06 -5.52,-0.1 -7.58,-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#0f191d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5157.24,2480.85 c -0.32,0 -0.72,1.95 -1.15,5.54 -0.61,5.04 -1.29,13.32 -2.01,23.97 -0.94,14.17 -1.94,32.54 -2.84,53.1 -0.26,5.94 -0.52,12.06 -0.76,18.32 -1.06,27.33 -1.72,52.14 -1.93,70.34 l 0.85,5.72 8.1,-173.37 h 0.36 c -0.01,-0.07 -0.01,-0.13 -0.01,-0.19 -0.15,-2.23 -0.35,-3.42 -0.6,-3.43 h -0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4833.53,2329.01 c -0.35,-0.12 -1.88,3.43 -4.37,9.96 -2.5,6.52 -5.84,16.07 -9.7,27.95 -7.71,23.75 -17.24,57 -24.7,94.45 -7.43,37.47 -11.06,71.93 -12.24,96.91 -0.61,12.49 -0.79,22.6 -0.61,29.59 0.14,6.99 0.4,10.85 0.76,10.86 0.82,0.01 1.38,-15.41 3.52,-40.2 2.12,-24.79 6.3,-58.91 13.67,-96.15 7.43,-37.21 16.33,-70.44 23.13,-94.4 3.17,-11.11 5.87,-20.58 8.09,-28.37 1.9,-6.72 2.79,-10.49 2.45,-10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4898.78,2206.68 c -1.38,-0.41 -5.37,8.77 -8.92,20.51 -3.55,11.75 -5.32,21.61 -3.94,22.03 1.38,0.41 5.37,-8.77 8.92,-20.52 3.56,-11.74 5.32,-21.6 3.94,-22.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4921.09,2208.31 c -1.32,-0.34 -5.68,13.44 -5.89,31.12 -0.31,17.67 3.64,31.58 4.98,31.27 1.48,-0.27 -0.08,-14.14 0.22,-31.2 0.2,-17.05 2.17,-30.88 0.69,-31.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4811.82,2394.65 c -0.64,-1.29 -52.17,23.16 -115.08,54.59 -62.93,31.45 -113.41,57.98 -112.76,59.26 0.64,1.29 52.16,-23.15 115.09,-54.6 62.9,-31.43 113.39,-57.97 112.75,-59.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#c0776a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4902.62,2858.08 c 1.15,50.59 1.43,103.86 1.43,103.86 0,0 -64.88,12.51 -76.19,97.89 -10.78,81.42 19.38,272.47 19.38,272.47 94.78,35.83 193.28,3.35 258.22,-73.45 l -16.12,-410.74 c -1.87,-47.68 -44.36,-84.05 -95.4,-81.66 -51.56,2.42 -92.42,43.42 -91.32,91.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4842.32,3179.61 c -0.36,-5.75 4.22,-10.8 10.22,-11.27 6,-0.48 11.14,3.79 11.49,9.54 0.36,5.75 -4.22,10.8 -10.21,11.28 -6.01,0.48 -11.15,-3.8 -11.5,-9.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4838.25,3193.94 c 1.32,-1.46 9.74,4.45 21.47,4.11 11.73,-0.17 20.18,-6.43 21.49,-5.02 0.65,0.62 -0.66,3.22 -4.34,6.05 -3.63,2.81 -9.86,5.62 -17.16,5.77 -7.32,0.16 -13.53,-2.38 -17.14,-5.04 -3.67,-2.67 -4.96,-5.21 -4.32,-5.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4961.37,3172.2 c -0.35,-5.75 4.23,-10.79 10.23,-11.28 5.99,-0.47 11.15,3.79 11.5,9.55 0.35,5.75 -4.23,10.8 -10.23,11.28 -5.99,0.48 -11.15,-3.8 -11.5,-9.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4960.58,3186.52 c 1.32,-1.46 9.74,4.44 21.47,4.11 11.72,-0.17 20.18,-6.43 21.5,-5.03 0.63,0.63 -0.67,3.22 -4.36,6.05 -3.62,2.82 -9.84,5.62 -17.16,5.78 -7.3,0.15 -13.52,-2.38 -17.13,-5.05 -3.67,-2.67 -4.97,-5.21 -4.32,-5.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4915.75,3100.6 c 0.07,0.66 -7.19,2.11 -18.97,3.92 -2.99,0.39 -5.81,1.06 -6.26,3.12 -0.66,2.18 0.68,5.38 2.23,8.83 3,7.17 6.15,14.7 9.45,22.58 13.14,32.17 22.74,58.65 21.43,59.17 -1.3,0.52 -13,-25.13 -26.15,-57.3 -3.16,-7.94 -6.19,-15.5 -9.07,-22.73 -1.23,-3.38 -3.28,-7.19 -1.87,-11.72 0.76,-2.26 2.91,-3.94 4.82,-4.51 1.9,-0.64 3.59,-0.71 5.07,-0.84 11.88,-0.95 19.25,-1.19 19.32,-0.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#ac584f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4904.05,2961.94 c 0,0 57.11,-5.16 114.66,27.45 0,0 -29.13,-57.7 -114.02,-47.55 l -0.64,20.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4998.14,3220.37 c -2.41,-3.67 -11.33,-2.04 -21.33,-0.24 -9.96,2.01 -18.86,3.78 -19.75,8.08 -0.99,4.12 9.34,9.82 22.68,7.27 13.34,-2.53 20.84,-11.64 18.4,-15.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4881.47,3237.59 c -0.91,-4.27 -10.47,-5.83 -21.49,-6.4 -11.03,-0.45 -20.68,0.23 -21.98,4.41 -1.32,4.04 8,10.61 21.26,11.2 13.26,0.63 23.14,-5.06 22.21,-9.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#ac584f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4915.94,3072.51 c -2.48,0.68 -5.26,-0.72 -6.5,-2.97 -1.48,-2.67 -0.8,-6.35 1.54,-8.32 2.33,-1.97 6.07,-2.02 8.45,-0.12 2.4,1.91 3.17,5.56 1.77,8.28 -1.4,2.71 -4.83,4.19 -7.77,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4918.68,3071.35 c 0.53,0.47 -1.87,3.35 -7,2.24 -2.36,-0.53 -5.47,-2.66 -6.42,-6.29 -0.93,-3.42 -0.08,-7.86 3.54,-10.63 3.75,-2.65 8.27,-2.1 11.25,-0.07 3.19,2.1 4.1,5.94 3.6,8.34 -1.03,5.27 -4.93,6.11 -5.04,5.37 -0.44,-0.66 1.36,-2.48 1.02,-5.6 -0.18,-1.53 -0.9,-2.95 -2.38,-3.67 -1.45,-0.8 -3.75,-0.79 -5.07,0.22 -1.38,0.97 -2.09,3.16 -1.8,4.84 0.21,1.67 1.33,2.93 2.69,3.7 2.78,1.57 5.25,0.83 5.61,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5066.16,3158.53 c -10.11,-23.44 -34.8,-41.5 -31.37,-66.8 2.2,-16.34 12.68,-31.57 10.64,-47.92 -2.56,-20.55 -23.9,-34.79 -26.91,-55.26 -3.71,-25.12 20.72,-44.64 30.48,-68.08 14.21,-34.14 -3.97,-72.52 -4.4,-109.49 -0.65,-56.63 47.51,-109.53 103.95,-114.18 22.83,-1.88 48.54,5.01 60.38,24.62 9.76,16.19 7.81,36.74 13.67,54.71 8.72,26.77 34.23,46.35 39.61,73.98 9.8,50.37 -51.08,92.05 -47.07,143.21 1.71,21.85 15.2,40.92 20.95,62.08 7.5,27.72 0.62,58.94 -17.87,80.92 -15.02,17.87 -36.81,29.62 -49.61,49.14 -14.51,22.14 -15.01,50.21 -20.48,76.11 -13.33,63.1 -60.73,117.93 -121.24,140.25 -60.52,22.32 -132.16,11.4 -183.29,-27.94 0,0 -14.54,-65.91 53.12,-76.93 67.65,-11.02 99,1.7 106.63,-25.42 0,0 -7.7,-31.68 20.26,-61.93 27.98,-30.26 54.26,-23.93 42.55,-51.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5174.12,2701.41 c -0.03,-0.18 -2.14,0.05 -6.17,0.65 -4.02,0.62 -9.92,1.96 -17.21,4.64 -14.45,5.28 -34.91,16.78 -52.35,38.75 -8.66,10.88 -16.78,24.09 -22.25,39.61 -5.6,15.43 -8.8,32.92 -9.1,51.34 -0.43,18.44 2.19,37.76 7.22,57.1 2.51,9.69 5.77,19.34 9.57,28.93 3.74,9.63 8.34,18.91 10.98,28.73 2.84,9.79 2.46,19.79 -0.1,29.33 -2.61,9.55 -7.05,18.51 -11.38,27.38 -4.35,8.86 -8.79,17.7 -11.65,27.1 -2.91,9.32 -3.99,19.37 -2.1,28.74 3.99,18.84 15.43,32.78 22.18,47.08 7.15,14.18 9.38,29.15 9.05,42.6 -1.21,27.24 -12.82,47.38 -22.29,58.99 -9.89,11.63 -17.38,16.05 -17,16.54 0,0 7.93,-3.74 18.53,-15.22 10.16,-11.46 22.7,-31.88 24.44,-60.15 0.6,-13.93 -1.53,-29.71 -8.84,-44.64 -6.9,-14.83 -17.94,-28.87 -21.35,-46.11 -3.52,-17.37 4.7,-35.26 13.61,-52.67 4.36,-8.88 8.98,-18.07 11.8,-28.28 2.8,-10.14 3.21,-21.59 0.12,-32.04 -2.84,-10.49 -7.53,-19.89 -11.19,-29.3 -3.74,-9.4 -6.96,-18.85 -9.45,-28.32 -4.99,-18.91 -7.64,-37.77 -7.34,-55.72 0.11,-36.04 12.49,-67.56 29.43,-88.74 16.61,-21.68 36.24,-33.38 50.21,-39.14 14.15,-5.73 22.76,-6.59 22.63,-7.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5164.16,3206.02 c 0.03,-0.33 -5.24,-1.28 -14.9,-2.22 -9.62,-0.8 -23.83,-1.91 -41.18,1.08 -16.95,3.1 -38.4,11.43 -51.98,31.54 -6.66,10.09 -9.3,22.3 -13.64,33.57 -4.08,11.4 -11.97,21.27 -22.78,28.11 -21.88,13.86 -47.62,15.57 -70.14,18.31 -22.63,2.55 -43.88,7.35 -58.28,18.16 -14.51,10.32 -21.95,23.73 -23.87,33.39 -1.08,4.83 -0.99,8.72 -0.77,11.27 0.36,2.57 0.64,3.88 0.82,3.86 0.64,-0.01 -0.69,-5.5 1.93,-14.64 2.41,-9.04 9.93,-21.4 24,-30.87 13.87,-9.82 34.2,-14.12 56.74,-16.4 22.31,-2.52 48.96,-3.91 72.4,-18.71 11.56,-7.21 20.52,-18.54 24.71,-30.64 4.45,-11.9 6.94,-23.62 12.92,-32.81 12.19,-18.61 32.36,-27.12 48.64,-30.52 16.7,-3.37 30.77,-2.85 40.36,-2.68 9.63,0.31 14.98,0.58 15.02,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5139.35,3287.46 c 0.06,-0.26 -4.04,-1.53 -11.72,-1.73 -7.62,-0.21 -19.03,1.14 -31.57,7.11 -6.26,2.97 -12.68,7.23 -18.58,12.92 -6,5.66 -10.92,12.98 -15.52,20.7 -9.02,15.21 -17.69,33.97 -36.39,41.73 -18.32,7.85 -38.5,6.1 -56.03,4.92 -17.7,-1.75 -34.29,-2.26 -47.82,0.4 -13.62,2.37 -23.84,8.01 -29.5,13.23 -2.87,2.59 -4.82,4.89 -5.89,6.6 -1.12,1.69 -1.63,2.6 -1.49,2.71 0.42,0.32 2.81,-3.22 8.67,-7.74 5.82,-4.51 15.65,-9.34 28.82,-11.17 13.17,-2.1 29.02,-1.26 46.8,0.75 17.62,1.39 38.4,3.6 58.55,-4.94 9.96,-4.24 18.09,-11.72 23.87,-19.83 5.89,-8.11 10.11,-16.59 14.55,-24.24 4.42,-7.65 8.95,-14.65 14.42,-20.05 5.41,-5.46 11.35,-9.67 17.19,-12.7 11.72,-6.08 22.57,-7.97 29.97,-8.37 7.44,-0.43 11.61,0.15 11.67,-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#33535f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5203.97,2722.99 c -0.51,0.23 2.67,6.66 6.36,18.97 3.67,12.27 7.31,30.72 6.66,53.6 -0.78,22.74 -6.25,50.24 -21.31,76.36 -7.32,13.1 -18.43,24.77 -27.49,39.15 -4.5,7.18 -8.37,15.23 -10.07,24.14 -1.67,8.92 -0.66,18.39 2.21,26.99 5.61,17.26 15.66,31.81 17.82,47.68 2.67,15.92 -5.37,30.44 -12.98,43.35 -3.85,6.58 -7.71,13.08 -10.71,19.88 -2.99,6.8 -4.9,13.96 -5.65,20.88 -1.52,13.9 0.1,26.67 1.13,38.13 2.88,22.84 0.76,41.61 -4.74,53.14 -5.34,11.68 -12.32,15.18 -11.8,15.65 l 1.21,-0.57 c 0.73,-0.48 1.9,-1.11 3.18,-2.28 2.67,-2.17 6.23,-6.02 9.23,-11.91 6.33,-11.68 9.05,-31.3 6.58,-54.34 -0.81,-11.51 -2.14,-24.13 -0.51,-37.29 1.33,-13.29 8.18,-25.84 16.21,-38.84 3.89,-6.59 8,-13.46 10.89,-21.25 2.96,-7.74 4.3,-16.58 3,-25.25 -2.43,-17.49 -12.73,-32.29 -17.9,-48.55 -2.68,-8.11 -3.54,-16.45 -2.08,-24.48 1.52,-8.01 5.03,-15.49 9.32,-22.39 8.57,-13.82 19.75,-25.72 27.3,-39.44 15.35,-27.15 20.52,-55.44 20.85,-78.67 0.17,-23.39 -4.11,-42.06 -8.41,-54.3 -2.25,-6.11 -4.13,-10.79 -5.76,-13.81 -1.51,-3.07 -2.38,-4.63 -2.54,-4.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4796.62,859.73 c 0,0 -67.34,638.43 -71.21,874.32 -3.87,235.91 106.07,468.67 106.07,468.67 l 430.83,18.22 c 0,0 85.15,-239.36 86.68,-339.89 2.96,-195.39 -51.92,-388.34 -45.59,-543.33 l 14.4,-477.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#fafaf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5332.22,1644.58 c 0.09,-0.15 -2.36,-1.99 -7.03,-5.32 -1.2,-0.85 -2.51,-1.78 -3.93,-2.77 -1.35,-1.15 -2.66,-2.58 -4.17,-4.03 -3.03,-2.91 -6.55,-6.2 -9.6,-10.75 -13.91,-17.04 -24.06,-47.47 -33.7,-85.45 -5.32,-18.86 -10.7,-40.02 -21.82,-60.73 -2.97,-5.06 -5.64,-10.42 -9.56,-15.13 -1.87,-2.39 -3.57,-4.97 -5.62,-7.27 l -6.64,-6.63 c -9,-8.85 -20.39,-15.52 -32.4,-20.79 -24.12,-10.57 -51.34,-15.58 -76.22,-28.06 -25.03,-12.19 -43.79,-35.82 -55.29,-63.03 -12.13,-27.1 -19.49,-55.55 -29.61,-82.11 -9.94,-26.35 -23.47,-52 -44.97,-68.2 -21.33,-16.79 -47.68,-20.63 -70.51,-22.1 -23.19,-1.35 -44.67,-0.69 -63.94,-3.6 -19.19,-2.66 -36.2,-8.75 -48.22,-18.2 -12.07,-9.48 -19.11,-21.37 -22.42,-31.55 -3.41,-10.3 -2.8,-18.99 -1.67,-24.52 1.12,-5.62 2.7,-8.3 2.35,-8.45 0,0 -1.89,2.53 -3.36,8.2 -1.51,5.6 -2.49,14.59 0.75,25.36 3.13,10.66 10.14,23.12 22.53,33.24 12.43,10.12 29.92,16.6 49.49,19.56 19.62,3.2 41.34,2.74 64.2,4.27 22.61,1.64 47.83,5.6 67.88,21.61 20.31,15.44 33.36,40.11 43.13,66.2 9.94,26.25 17.25,54.74 29.63,82.43 11.61,27.68 31.51,52.82 57.73,65.44 25.86,12.84 53.1,17.69 76.61,27.92 11.71,5.07 22.59,11.37 31.19,19.73 l 6.37,6.26 c 1.98,2.19 3.62,4.66 5.44,6.95 3.79,4.47 6.42,9.66 9.34,14.52 10.95,19.99 16.54,40.92 22.06,59.67 10.07,37.77 20.93,68.7 35.66,85.72 3.23,4.53 6.95,7.79 10.15,10.63 1.59,1.41 2.98,2.82 4.4,3.91 1.49,0.94 2.87,1.81 4.13,2.61 4.94,3.09 7.55,4.62 7.64,4.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#fafaf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5334.87,1940.02 c 0.18,0.01 0.38,-2.92 0.56,-8.55 0.09,-5.62 -0.59,-13.96 -2.99,-24.43 -5,-20.81 -20.2,-49.39 -48.67,-75.25 -14.06,-12.99 -31.04,-25.55 -50.45,-36.86 -19.31,-11.45 -40.6,-22.35 -62.42,-34.68 -21.74,-12.37 -44.16,-26.34 -63.86,-44.91 -19.96,-18.34 -34.91,-42.44 -48.37,-67.97 -13.6,-25.48 -25.64,-51.43 -41.94,-73.89 -8.09,-11.22 -17.23,-21.47 -27.34,-30.24 -10.18,-8.71 -21.26,-15.79 -32.52,-21.66 -22.6,-11.73 -45.62,-18.98 -66.95,-25.66 -21.37,-6.61 -41.32,-12.46 -58.75,-19.77 -17.46,-7.2 -32.59,-15.35 -44.81,-24 -12.23,-8.65 -21.53,-17.73 -28.13,-25.94 -13.32,-16.49 -16.12,-28.44 -16.87,-28.04 -0.17,0.05 0.78,2.83 2.77,8.1 2.32,5.11 5.89,12.72 12.51,21.19 6.47,8.55 15.74,18.02 28.02,27.05 12.27,9.03 27.51,17.52 45.09,25.03 17.58,7.62 37.61,13.72 58.87,20.5 21.23,6.84 43.98,14.2 66.02,25.79 10.98,5.8 21.71,12.74 31.5,21.18 9.75,8.52 18.57,18.46 26.45,29.45 15.88,21.97 27.81,47.71 41.48,73.36 13.51,25.64 28.9,50.44 49.47,69.23 20.25,18.98 43.07,33.05 65.01,45.38 22.01,12.28 43.34,23.02 62.58,34.23 19.32,11.04 36.14,23.22 50.16,35.84 28.34,25.14 43.67,52.79 49.2,73.06 5.37,20.47 3.58,32.51 4.38,32.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#fafaf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4727.59,1700.25 c -0.09,-0.03 -0.38,0.61 -0.88,1.93 -0.43,1.34 -1.35,3.26 -1.93,5.96 -1.22,5.34 -1.99,13.78 1,23.97 5.56,20.36 27.68,45.69 63.32,58.39 17.74,6.09 37.86,9.77 58.82,15.25 20.72,5.59 43.3,13.41 60.17,30.74 8.37,8.55 15.45,18.73 21.33,29.92 5.75,11.29 10.48,23.41 14.95,35.92 8.96,24.94 16.48,52.05 31.7,76.68 15.11,24.83 39.74,42.08 65.23,50.72 25.43,9.34 51.06,13.48 74.85,18.97 23.86,5.19 46.16,11.91 65.09,22.16 18.65,10.6 33.52,24.71 44.04,39.67 21.58,30 27.22,60.72 27.99,81.01 0.47,20.63 -2.81,31.86 -2.13,31.96 0,0 4,-11.04 4.15,-32 -0.15,-20.6 -5.29,-52.07 -27.01,-83.1 -10.6,-15.47 -25.72,-30.18 -44.94,-41.31 -19.4,-10.74 -42.17,-17.72 -66.12,-23.07 -23.91,-5.64 -49.4,-9.89 -74.14,-19.07 -24.9,-8.57 -48.03,-24.9 -62.6,-48.7 -14.69,-23.73 -22.24,-50.53 -31.31,-75.63 -4.53,-12.6 -9.38,-24.93 -15.33,-36.51 -6.1,-11.51 -13.54,-22.11 -22.37,-31.03 -17.91,-18.17 -41.5,-26.04 -62.46,-31.5 -21.26,-5.37 -41.26,-8.81 -58.75,-14.58 -34.67,-11.83 -56.68,-36.11 -62.54,-55.49 -3.17,-9.72 -2.78,-17.88 -1.92,-23.17 1.12,-5.26 2.02,-8.02 1.79,-8.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#fafaf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5297.82,1160.42 c 0.18,0.02 0.41,-2.13 0.7,-6.27 0.23,-4.13 -0.09,-10.32 -1.85,-18.05 -3.52,-15.41 -15.42,-36.49 -37.79,-54.03 -11.02,-8.88 -24.35,-17.03 -39.66,-23.54 -15.26,-6.55 -32.15,-11.73 -49.79,-17.22 -17.61,-5.5 -36.1,-11.26 -54.08,-19.75 -18.1,-8.29 -34.82,-20.43 -49.22,-35.9 -14.59,-15.281 -27.17,-31.98 -41.14,-46.711 -13.91,-14.828 -29.71,-27.039 -46.08,-36.07 -32.91,-18.168 -67.03,-24.41 -95.11,-24.719 -28.28,-0.32 -50.73,5.629 -65.45,10.871 -7.43,2.59 -12.95,5.18 -16.61,7.117 -3.69,1.852 -5.59,2.883 -5.51,3.051 0.08,0.16 2.13,-0.57 5.95,-2.097 3.77,-1.622 9.37,-3.891 16.82,-6.153 14.76,-4.597 36.98,-9.879 64.74,-9.109 27.55,0.781 60.87,7.281 92.82,25.23 15.94,8.95 31.14,20.809 44.72,35.379 13.67,14.512 26.21,31.199 41.08,46.813 14.65,15.778 32.27,28.528 50.8,36.908 18.47,8.64 37.2,14.34 54.87,19.72 17.67,5.37 34.48,10.37 49.52,16.61 15.01,6.19 28.15,13.98 39.04,22.46 22.13,16.78 34.08,36.83 38.13,51.65 3.94,14.97 2.38,23.83 3.1,23.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#c0776a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5248.71,2485.97 -83.3,-1.97 c -5.47,-28.06 -18.84,-47.26 -18.84,-47.26 -69.66,120.92 -123.67,282.92 -137.08,348.03 1.96,6.51 4.27,13.7 7.16,21.75 3.33,9.28 0.47,26.85 -1.1,36.61 -2.34,14.49 -6.39,34 -7.61,43.03 -3.71,27.51 -8.14,31.83 -17.74,28.72 -13.05,-4.23 5.35,-77.27 -5.35,-78.85 -5.75,-0.85 -12.78,24.17 -14.81,44.7 -2.04,20.53 -11.33,83.68 -18.12,87.89 -9.94,6.17 -18.61,-3.59 -16.1,-24.03 2.54,-20.7 5.75,-82.4 -5.1,-83.24 -10.69,-0.82 -19.66,103.88 -19.66,103.88 0,0 1.69,22.78 -10.87,22.24 -22.66,-0.99 -4.95,-111.37 -3.02,-121.82 1.36,-7.28 -10.41,-8.61 -11.45,-0.72 -1.06,8.13 -6.53,104.71 -29.6,103.93 -17.71,-0.6 13.71,-90.96 3.77,-111.91 -9.94,-20.94 -16.84,71.14 -33.75,69.87 -6.29,-0.47 -10.94,-1.7 0.62,-53.81 6.22,-28.01 24.47,-79.51 40.43,-122.14 26.79,-144.51 144.36,-606.77 328.7,-522.15 103.14,47.35 145,257.2 145,257.2 l -92.18,0.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#ac584f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4893.23,2858.57 c 0,0 0.84,-0.16 2.41,0.33 1.4,0.43 4.19,2.19 3.76,5.77 -0.24,6.21 -1.22,15.25 -2.65,26.94 -1.07,11.77 -4.59,25.89 -4.6,42.61 -0.14,8.37 0.08,17.37 0.56,26.91 0.31,4.77 0.4,9.72 1.45,14.4 0.79,4.53 3.82,9.71 7.32,9.09 l 0.39,-0.07 0.16,0.01 c 3.56,0.16 6.34,-2.61 7.48,-6.84 1.25,-4.06 1.57,-8.84 1.31,-13.39 l -0.01,-0.19 0.02,-0.13 c 2.33,-25.59 4.85,-53.59 10.68,-83.5 0.82,-3.73 1.65,-7.49 2.81,-11.28 0.57,-1.9 1.25,-3.81 2.08,-5.73 0.53,-0.99 0.88,-1.93 1.7,-2.97 0.71,-0.87 1.61,-2.39 4.18,-2.62 4.15,0.31 5.35,3.45 6.29,5.25 0.89,2.08 1.45,4.12 1.87,6.15 0.86,4.07 1.29,8.12 1.6,12.21 1.11,16.3 0.54,32.95 -0.66,50.01 -0.39,8.63 -2.51,17.24 -1.05,25.05 0.7,3.85 2.3,7.73 4.92,9.33 1.28,0.78 2.73,0.95 4.31,0.55 l 2.37,-1.03 c 0.66,-0.64 0.51,-0.35 1.11,-1.48 3.34,-7.15 5.06,-16.48 6.93,-25.14 1.78,-8.84 3.31,-17.86 4.73,-26.98 1.4,-9.12 2.69,-18.35 3.78,-27.65 0.9,-9.29 2.24,-19.05 4.61,-28.44 1.2,-4.73 2.53,-9.45 4.51,-14.13 1.01,-2.35 2.07,-4.68 4.12,-7.07 0.74,-1.02 3.08,-2.93 5.99,-2.18 2.82,0.94 3.62,3.18 4.08,4.49 1.62,5.75 1.14,10.53 1.06,15.56 -0.21,4.96 -0.62,9.87 -1.04,14.77 -0.72,8.42 -1.52,16.75 -1.81,24.97 -0.13,4.09 -0.14,8.17 0.3,12.03 0.25,1.88 0.57,3.81 1.21,5.21 l 0.97,1.49 0.39,0.25 1.29,0.37 c 6.64,2.74 8.84,-6.49 10.61,-13.93 1.53,-7.75 2.51,-15.77 4.07,-23.66 2.64,-15.75 5.99,-31.4 7.75,-46.44 0.73,-7.46 1.26,-15.21 -0.88,-21.53 -2.36,-7.23 -4.7,-14.38 -7.02,-21.45 l -0.2,-0.64 0.14,-0.67 c 12.19,-53.77 29.08,-101.88 44.75,-144.59 15.83,-42.67 31.66,-79.55 45.63,-109.71 13.93,-30.18 26.43,-53.44 35.06,-69.3 4.38,-7.52 7.84,-13.47 10.4,-17.88 2.42,-4.03 3.73,-6.09 3.87,-6.01 0.14,0.08 -0.92,2.28 -3.08,6.46 -2.38,4.51 -5.58,10.58 -9.63,18.26 -8.13,16.11 -20.14,39.54 -33.61,69.85 -13.51,30.27 -28.92,67.22 -44.38,109.89 -15.3,42.67 -31.9,90.91 -43.75,144.11 l -0.06,-1.31 c 2.3,6.97 4.65,14.03 7,21.16 2.7,8.16 1.9,16.13 1.23,23.93 -1.79,15.64 -5.06,30.83 -7.66,46.66 -1.55,7.82 -2.49,15.85 -4.11,24.05 -0.94,4.08 -1.83,8.21 -4.08,12.38 -1.08,2.02 -2.75,4.32 -5.52,5.56 -2.79,1.21 -5.64,0.87 -7.89,0.32 l -1.68,-0.48 -2.27,-1.28 c -1.27,-1.12 -2,-2.38 -2.53,-3.56 -1.05,-2.4 -1.35,-4.62 -1.66,-6.83 -0.5,-4.39 -0.47,-8.66 -0.34,-12.9 0.29,-8.48 1.1,-16.87 1.81,-25.26 0.41,-4.89 0.82,-9.75 1.03,-14.54 0.17,-4.67 0.33,-9.82 -0.74,-13.44 -0.25,-1.05 -0.75,-0.85 -0.17,-1.36 l 0.02,-0.04 0.06,-0.38 -0.02,0.11 0.03,0.34 0.15,0.47 -0.61,0.55 c -1.09,1.27 -2.2,3.35 -3.05,5.42 -1.78,4.19 -3.09,8.74 -4.25,13.28 -2.29,9.17 -3.58,18.27 -4.51,27.72 -1.11,9.4 -2.43,18.68 -3.86,27.86 -1.45,9.18 -3.01,18.25 -4.83,27.22 -2.06,9.02 -3.39,17.69 -7.61,26.71 -0.25,0.91 -2.04,2.92 -3.13,3.51 -1.12,0.67 -2.37,1.19 -3.72,1.57 -2.7,0.74 -5.99,0.4 -8.46,-1.18 -4.96,-3.28 -6.49,-8.49 -7.39,-13.01 -0.8,-4.66 -0.68,-9.26 -0.17,-13.7 0.5,-4.27 0.92,-8.46 1.25,-12.68 1.26,-16.84 1.9,-33.41 0.9,-49.25 -0.27,-3.94 -0.68,-7.86 -1.44,-11.55 -0.36,-1.86 -0.87,-3.64 -1.52,-5.18 l -1.09,-1.87 c -0.37,-0.84 -0.68,0.19 -0.66,-1.16 0.51,1.03 0.02,0.45 -0.37,1.31 l -1.19,2.08 c -0.71,1.63 -1.33,3.35 -1.88,5.13 -1.12,3.55 -1.97,7.22 -2.78,10.86 -5.93,29.37 -8.72,57.45 -11.29,82.85 v -0.32 c 0.21,5.14 -0.12,10.04 -1.64,14.87 -0.76,2.37 -1.88,4.78 -3.9,6.66 -1.99,1.92 -4.86,2.79 -7.41,2.7 l 0.54,-0.06 c -4.01,0.72 -6.95,-1.72 -8.62,-4.13 -1.71,-2.48 -2.48,-5.17 -3.07,-7.76 -1.1,-5.25 -1.08,-10.25 -1.33,-15.03 -0.37,-9.62 -0.44,-18.67 -0.16,-27.13 0.32,-17.06 4.16,-31.19 5.52,-42.81 1.74,-11.62 3.03,-20.64 3.6,-26.72 0.63,-2.89 -1.7,-4.75 -2.92,-5.23 -1.4,-0.61 -2.23,-0.7 -2.21,-0.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#c0776a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4241.98,2348.29 c 0,0 -27.67,1.32 -57.93,-6.64 -51.64,-13.59 -140.79,-67.62 -144.48,-134.36 h 64.75 c 0,0 -36.26,-77.19 -25.61,-70.04 27.65,18.55 82.69,74.47 82.69,74.47 l 80.58,136.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5125.25,3510.17 c -1.44,-0.12 -7.32,53.42 -13.13,119.57 -5.82,66.17 -9.37,119.9 -7.94,120.03 1.44,0.12 7.31,-53.4 13.13,-119.58 5.82,-66.15 9.37,-119.89 7.94,-120.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5409.32,3746.5 c 1.17,-0.84 -42.58,-64.33 -97.71,-141.8 -55.13,-77.5 -100.78,-139.63 -101.95,-138.81 -1.17,0.84 42.57,64.32 97.71,141.82 55.13,77.48 100.78,139.63 101.95,138.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5527.34,3458.73 c 0.3,-1.41 -50.76,-13.1 -114.01,-26.1 -63.28,-13 -114.79,-22.4 -115.09,-20.99 -0.28,1.41 50.77,13.09 114.04,26.09 63.26,13 114.78,22.4 115.06,21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2126.25,2085.17 1772.64,267.18 1726.35,29.1914 4086.98,40.832 c 105.94,0.5274 199.83,94.59 233.91,234.348 l 418.59,1716.37 c 25.88,106.09 -30.9,216.44 -111.31,216.36 l -2389.24,-2.51 c -52.75,-0.06 -98.88,-49.28 -112.68,-120.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#303f9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4117.15,43.5313 c 16.99,4.0898 31.45,8.6289 43.77,13.3593 -14.14,-6.2304 -28.78,-10.7304 -43.77,-13.3593"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#303f9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4141.3,97.082 c -256.05,0 -280.74,293.059 -280.76,293.27 l -225.43,1816.518 993.06,1.04 c 0.03,0 0.05,0 0.09,0 67.02,0 117.6,-76.73 117.55,-163.71 -0.02,-17.32 -2.03,-35.04 -6.33,-52.65 L 4559.28,1252.67 4487.5,958.328 4320.89,275.18 c -17.57,-72.059 -51.04,-131.969 -93.87,-173.18 2.16,3.422 2.82,5.449 2.82,5.449 -32.21,-7.129 -61.67,-10.367 -88.54,-10.367"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3860.54,390.352 3610.6,2404.43 c -10.24,82.52 -75.98,144.08 -153.6,143.83 l -548.06,-1.79 c -40.57,-0.14 -79.46,-17.38 -108.27,-48.01 l -260.24,-276.64 -1524.27,-7.96 c -93.14,-0.48 -164.703,-88.62 -152.359,-187.65 L 1095.86,164.691 c 10.27,-82.4097 75.89,-143.8902 153.4,-143.7418 l 2656.46,5.25 c 295.87,-6.1289 324.12,81.2498 324.12,81.2498 -339.08,-75.1404 -369.27,282.672 -369.3,282.903"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#b3e5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2625.49,697.219 -295.5,265.832 89.59,96.229 295.51,-265.839 -89.6,-96.222 m -394.52,354.911 -295.5,265.83 89.59,96.23 295.5,-265.83 -89.59,-96.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#b3e5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2062.61,675.879 -99.01,89.082 267.37,287.169 89.59,96.23 267.38,287.17 99.02,-89.08 -267.38,-287.17 -89.59,-96.229 -267.38,-287.172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4239.86,3392.77 c -6.38,2.73 -10.97,8.95 -11.3,16.36 l -3.99,92.83 c -0.26,5.84 2.24,11.47 6.74,15.18 4.5,3.73 10.5,5.13 16.18,3.78 14.92,-3.52 31.38,-0.28 45.15,8.92 12.68,8.46 21.19,20.92 23.35,34.19 2.16,13.22 -1.94,27.86 -11.22,40.16 -9.96,13.16 -24.66,22.04 -39.41,23.72 -30.11,3.47 -62.62,-19.6 -70.99,-50.37 -2.7,-9.95 -12.95,-15.82 -22.89,-13.12 -10.11,2.78 -15.82,12.96 -13.12,22.9 13.14,48.38 63.06,83.22 111.28,77.67 25,-2.88 48.69,-16.85 64.89,-38.3 15.42,-20.4 22.08,-45.42 18.29,-68.67 -3.82,-23.45 -18.2,-45.03 -39.46,-59.22 -15.36,-10.25 -32.99,-15.9 -50.61,-16.52 l 3.1,-71.56 c 0.44,-10.29 -7.55,-19 -17.84,-19.43 -2.89,-0.13 -5.66,0.41 -8.15,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "#5c6bc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4267.22,3354.84 c 0.57,-8.41 -5.77,-15.7 -14.18,-16.28 -8.41,-0.58 -15.71,5.77 -16.28,14.19 -0.58,8.4 5.77,15.69 14.18,16.27 8.42,0.58 15.7,-5.77 16.28,-14.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#17282f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3918.53,3523.67 c 0.12,0 0.43,2.06 0.9,6.09 0.47,4.35 1.13,10.27 1.96,17.88 0.45,7.91 2.47,17.47 4.84,28.74 1.31,5.6 2,11.83 4.05,18.13 1.95,6.34 4.02,13.07 6.21,20.19 9.67,28.09 24.59,61.76 49.72,95.27 24.94,33.43 60.01,66.45 105.03,91.48 22.16,13.22 47.52,22.43 74.09,30.56 27,6.4 55.61,11.87 85.5,11.17 14.95,0.8 30.02,-1.39 45.37,-2.68 7.68,-0.74 15.23,-2.79 22.93,-4.13 7.71,-1.43 15.46,-2.93 23.01,-5.55 30.87,-7.92 60.86,-22.48 89.44,-40.53 57.37,-36.1 105.68,-94.81 132.18,-166 13.29,-35.61 19.65,-74.65 19.6,-114.08 0.79,-39.51 -6.86,-79.65 -20.92,-117.42 l -4.51,-11.42 -0.6,-1.51 0.62,-1.41 c 25.08,-57.77 49.68,-114.43 73.52,-169.32 l 4.19,4.77 c -51.64,19.85 -101.71,39.08 -149.75,57.54 l -1.86,0.71 -1.45,-1.41 c -41.55,-40.25 -91.17,-67.47 -141.42,-81.64 -50.4,-14.21 -101.16,-14.94 -147.33,-6.74 -46.27,8.2 -87.93,25.9 -122.67,48.65 -34.84,22.75 -62.78,50.41 -84.32,78.51 -21.38,28.43 -35.47,57.57 -46.1,83.59 -9.36,26.6 -15.1,50.21 -17.88,69.75 -1.18,9.76 -2.23,18.44 -3.14,26.01 -0.2,7.48 -0.36,13.84 -0.5,19.11 -0.17,4.91 -0.29,8.79 -0.39,11.71 -0.12,2.63 -0.23,3.98 -0.32,3.98 -0.09,0 -0.17,-1.33 -0.24,-3.97 -0.04,-2.93 -0.1,-6.8 -0.15,-11.74 -0.01,-5.29 -0.03,-11.69 -0.04,-19.21 0.77,-7.64 1.65,-16.39 2.64,-26.23 2.47,-19.73 7.93,-43.62 17.09,-70.62 10.45,-26.41 24.44,-56.04 45.85,-85 21.58,-28.65 49.72,-56.89 84.93,-80.19 35.11,-23.3 77.32,-41.51 124.29,-50.05 46.87,-8.54 98.47,-8 149.81,6.29 51.18,14.26 101.81,41.85 144.26,82.81 l -3.31,-0.7 c 48.02,-18.53 98.06,-37.84 149.68,-57.77 l 7.55,-2.91 -3.34,7.69 c -23.8,54.92 -48.37,111.58 -73.42,169.37 l 0.02,-2.91 4.61,11.66 c 14.38,38.62 22.17,79.66 21.36,120.04 0.03,40.3 -6.54,80.21 -20.15,116.58 -27.15,72.71 -76.57,132.46 -135.1,169.08 -29.15,18.32 -59.73,33.02 -91.17,41 -7.69,2.62 -15.57,4.13 -23.42,5.56 -7.85,1.34 -15.53,3.39 -23.33,4.1 -15.61,1.26 -30.94,3.41 -46.12,2.54 -30.38,0.59 -59.44,-5.09 -86.8,-11.75 -26.96,-8.39 -52.63,-17.89 -75.04,-31.44 -45.52,-25.67 -80.82,-59.42 -105.77,-93.49 -25.13,-34.13 -39.86,-68.36 -49.23,-96.81 -2.1,-7.21 -4.1,-14.04 -5.96,-20.46 -1.96,-6.37 -2.56,-12.67 -3.78,-18.33 -2.17,-11.4 -3.99,-21.04 -4.22,-29.01 -0.55,-7.65 -0.98,-13.62 -1.29,-18 -0.25,-4.05 -0.33,-6.12 -0.21,-6.13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.9bc1fae7feeb033903facabee37bb19d.svg";
export { ForwardRef as ReactComponent };